/* Others */
import { makeFetchActionCreators, makeFetchActionTypes } from "../../utils";

export const ACTION_TYPES_BASE_NAME = "player";
export const ACTION_TYPES_SET_ERROR = `${ACTION_TYPES_BASE_NAME}/SET_ERROR`;
export const actionTypes = makeFetchActionTypes(ACTION_TYPES_BASE_NAME);
const actionCreators = makeFetchActionCreators(ACTION_TYPES_BASE_NAME);
export const { fetch: fetchPlayerData, reset: resetPlayerData } = actionCreators;

export const setPlayerErrorState = (playerErrorType = "") => ({
  type: ACTION_TYPES_SET_ERROR,
  payload: playerErrorType
});
